<div
  class="row border border-primary bg-light-blue rounded-1 bg-light p-1"
  [style]="options.length === 2 ? 'width: 180px' : 'width: 345px'">
  <button
    *ngFor="let option of options; index as i"
    (click)="onSelectOption(option.value)"
    [class]="options.length === 2 ? 'col-6 btn' : 'col-4 btn'"
    [class.btn-primary]="selectedOption === option.value"
    [class.btn-transparent]="selectedOption !== option.value">
    {{ option.label }}
  </button>
</div>
